export const isURL = (string) => {
  return !!string.match(
    'https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,256}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)',
  )
}
